import { soundManager } from '../audio/SoundManager';

export class MuteButton {
    private button: HTMLButtonElement;
    private isMuted: boolean;
    private readonly MUTE_STATE_KEY = 'muteState';

    constructor() {
        // Load initial mute state from localStorage
        this.isMuted = localStorage.getItem(this.MUTE_STATE_KEY) === 'true';
        soundManager.setMute(this.isMuted);

        // Create button element
        this.button = document.createElement('button');
        this.button.style.position = 'fixed';
        this.button.style.bottom = '20px';
        this.button.style.left = '80px';
        this.button.style.padding = '10px';
        this.button.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
        this.button.style.border = 'none';
        this.button.style.borderRadius = '5px';
        this.button.style.cursor = 'pointer';
        this.button.style.color = 'white';
        this.button.style.fontSize = '20px';
        this.button.style.zIndex = '1000';
        this.button.style.width = '45px';
        this.button.style.height = '45px';
        this.button.style.display = 'flex';
        this.button.style.alignItems = 'center';
        this.button.style.justifyContent = 'center';

        // Set initial icon
        this.updateButtonIcon();

        // Add click handler
        this.button.addEventListener('pointerdown', () => {
            this.isMuted = !this.isMuted;
            localStorage.setItem(this.MUTE_STATE_KEY, this.isMuted.toString());
            soundManager.setMute(this.isMuted);
            this.updateButtonIcon();
        });

        // Add hover effects
        this.button.addEventListener('mouseenter', () => {
            this.button.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
        });
        this.button.addEventListener('mouseleave', () => {
            this.button.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        });

        // Add to document
        document.body.appendChild(this.button);
    }

    private updateButtonIcon() {
        // Use unicode speaker icons
        this.button.innerHTML = this.isMuted ? '🔇' : '🔊';
    }

    public dispose(): void {
        if (this.button && this.button.parentNode) {
            this.button.parentNode.removeChild(this.button);
        }
    }
} 